import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CardClients from "../admin-component/CardClients";
import CardTemplateList from "../admin-component/CardTemplateList";
import PageInfo from "./PageInfo";
import Stats from "./Stats";
import SurveyList from "./SurveyList";

const HomeDashboard = ({ surveys, clients, surveyors, getSurveys }) => {
  return (
    <>
      <div className="contentMain pe-0 overflow-hidden">
        <Row>
          <Col xl="9">
            <PageInfo get={getSurveys} />
            <Stats
              surveys={surveys?.count}
              clients={clients.count}
              surveyors={surveyors.count}
            />
            <SurveyList
              paginate={true}
              getSurveys={getSurveys}
              survey={surveys}
            />
          </Col>
          <Col xl="3" className="xl:mt-0 mt-3">
            <div className="rightMain">
              <CardClients clients={clients.data} />
              <CardTemplateList />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HomeDashboard;
